"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SVGEngine = void 0;
var SVGEngine = /** @class */ (function () {
    function SVGEngine() {
    }
    SVGEngine.getNode = function (type, v) {
        var n = document.createElementNS("http://www.w3.org/2000/svg", type);
        for (var p in v)
            n.setAttributeNS(null, p, v[p]);
        return n;
    };
    return SVGEngine;
}());
exports.SVGEngine = SVGEngine;
